import {nodeAddedMap} from './MutationHandler';
import {ensureShoelaceThemeLoaded, getShoelaceBaseUrl} from './utils';

const tagName = 'sl-tooltip';

export const TooltipController = Object.freeze({
  tagName,
  selector: tagName,
  moduleUrl: `${getShoelaceBaseUrl()}components/tooltip/tooltip.js`,
  async ensureLoaded() {
    return Promise.all([
      ensureShoelaceThemeLoaded(),
      import(/* webpackIgnore: true */ TooltipController.moduleUrl),
    ]);
  },
});

nodeAddedMap.set(TooltipController.selector, (target) => {
  if (!target.matches(TooltipController.selector)) {
    return;
  }

  if (!customElements.get(TooltipController.tagName)) {
    TooltipController.ensureLoaded();
  }
});
